/**
 * @flow
 * @relayHash d9b7168c5e1625811fef9a6fb8feff08
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteInvoiceSupplierMutationVariables = {|
  id: string
|};
export type DeleteInvoiceSupplierMutationResponse = {|
  +deleteInvoiceSupplier: {|
    +id: string
  |}
|};
export type DeleteInvoiceSupplierMutation = {|
  variables: DeleteInvoiceSupplierMutationVariables,
  response: DeleteInvoiceSupplierMutationResponse,
|};
*/


/*
mutation DeleteInvoiceSupplierMutation(
  $id: String!
) {
  deleteInvoiceSupplier(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteInvoiceSupplier",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "InvoiceSupplierModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteInvoiceSupplierMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteInvoiceSupplierMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteInvoiceSupplierMutation",
    "id": null,
    "text": "mutation DeleteInvoiceSupplierMutation(\n  $id: String!\n) {\n  deleteInvoiceSupplier(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6fd95f32bd6b65b0959a892bcabca200';
module.exports = node;
